export type CopilotProposalAction = {
  messageId: string;
  suggestionIndex: number;
  action: "applied" | "discarded";
};

/**
 * Conflicts in the current C2 contract are historical free text and are not
 * individually linked to fields. We may mark one as resolved only in the
 * unambiguous case: its message proposed exactly one change and that change
 * was explicitly applied. All other conflicts remain current warnings.
 */
export function isResolvedSingleSuggestionConflict(
  messageId: string,
  conflictCount: number,
  suggestionCount: number,
  actions: ReadonlyMap<string, CopilotProposalAction>,
): boolean {
  return (
    conflictCount > 0 &&
    suggestionCount === 1 &&
    actions.get(`${messageId}:0`)?.action === "applied"
  );
}
